var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('div',{staticClass:"playerHere"},[_c('vue-plyr',{staticClass:"vid-player"},[_c('div',{attrs:{"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.id}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }